import { React, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { API_URL, PAGE_ROUTE } from '../shared/constant';
import TableComponent from '../shared/table';
import LoaderComponent from '../shared/loader';
import axios from 'axios';
export default function ProductFeatureListComponent() {

    let columns = [{
        field: 'name',
        lable: 'Name'
    }, {
        field: 'product_name',
        lable: 'Product Name'
    }];

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);


    useEffect(() => {
        getCategory();
    }, []);

    useEffect(() => {
        isRecall && getCategory();
    }, [isRecall]);

    const getCategory = () => {
        setLoading(true);
        axios.post(API_URL.ADMIN_PRODUCT_FEATURE_LIST, {}).then(res => {
            setData(res.data.data);
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    }

    const onDelete = (item) => {
        let id = item.id;
        axios.post(API_URL.ADMIN_PRODUCT_FEATURE_DELETE + id).then((response) => {
            setIsRecall(true);
        });
    }

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_PRODUCT_FEATURE_EDIT + item.id, { replace: true });
    }
    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'> Product Feature
                        <NavLink to={PAGE_ROUTE.ADMIN_PRODUCT_FEATURE_CREATE} className="btn btn-primary">
                            Add
                        </NavLink>
                    </h4>

                    {
                        isLoading && <LoaderComponent></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <TableComponent
                                    columns={columns}
                                    data={data}
                                    onDelete={onDelete}
                                    onEdit={onEdit}>
                                </TableComponent>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}